/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererCurrentPlayedNote.module.scss"
import {TopPxForNote} from "ui/feature/piece-play/common/piece-renderer/PieceRendererNote";
import {MIDIToPitchName} from "util/pitch";

interface Props {
    midi: number;
    middleLinePadding: number;
}

const PieceRendererCurrentPlayedNote: React.FC<Props> = ({midi, middleLinePadding}) => {

    const top = React.useMemo(() => {
        return TopPxForNote(midi);
    }, [midi]);

    return (
        <div style={{
            left: `${-middleLinePadding - 12 + 1}px`,
            top: `${top}px`
        }} className={styles.container}>
            <b className={styles.pitchTitle}>{MIDIToPitchName(midi)}</b>
        </div>
    );
}

export default PieceRendererCurrentPlayedNote;
